export const SPORTS = {
  soccer: {
    label: "Soccer",
    accent: "#FF2D78",
    positions: ["Forward", "Midfielder", "Defender", "Goalkeeper"],
    stats: [
      { key: "appearances", label: "Apps" },
      { key: "starts", label: "Starts" },
      { key: "goals", label: "Goals" },
      { key: "assists", label: "Assists" },
      { key: "shots", label: "Shots" },
      { key: "shots_on_goal", label: "On Goal" },
      { key: "saves", label: "Saves" },
      { key: "fouls_won", label: "Fouls Won" },
      { key: "goalkeeper_starts", label: "GK Starts" },
    ],
    keyStats: ["goals", "assists", "appearances"],
    logColumns: [["starts", "GS"], ["xg", "xG"], ["goals", "G"], ["assists", "A"], ["shots", "SH"], ["shots_on_goal", "SOG"], ["saves", "SV"], ["fouls_won", "FW"]],
  },
  volleyball: {
    attrSeason: "2025",
    label: "Volleyball",
    accent: "#F59E0B",
    positions: ["Outside Hitter", "Opposite", "Middle Blocker", "Setter", "Libero", "Defensive Specialist"],
    stats: [
      { key: "matches_played", label: "Matches" },
      { key: "starts", label: "Starts" },
      { key: "kills", label: "Kills" },
      { key: "hitting_percentage", label: "Hit %" },
      { key: "attack_attempts", label: "Attempts" },
      { key: "attack_errors", label: "Attack Errors" },
      { key: "assists", label: "Assists" },
      { key: "service_aces", label: "Aces" },
      { key: "service_errors", label: "Serve Errors" },
      { key: "digs", label: "Digs" },
      { key: "total_blocks", label: "Blocks" },
      { key: "block_solos", label: "Solo Blocks" },
      { key: "block_assists", label: "Block Assists" },
      { key: "points", label: "Points" },
    ],
    keyStats: ["kills", "digs", "service_aces"],
    logColumns: [["kills", "K"], ["attack_errors", "E"], ["attack_attempts", "TA"], ["assists", "A"], ["service_aces", "SA"], ["digs", "D"], ["total_blocks", "B"], ["points", "PTS"]],
  },
  softball: {
    label: "Softball",
    accent: "#14B8A6",
    rosterOnly: true,
    attrSeason: "2025",
    positions: ["Pitcher", "Catcher", "Infielder", "Outfielder", "Utility", "1B", "2B", "3B", "SS", "LF", "CF", "RF"],
    stats: [],
    keyStats: [],
    logColumns: [],
  },
  basketball: {
    label: "Basketball",
    accent: "#8B5CF6",
    rosterOnly: true,
    attrSeason: "2025-26",
    positions: ["Guard", "Forward", "Center", "Guard/Forward", "Forward/Center"],
    stats: [],
    keyStats: [],
    logColumns: [],
  },
  lacrosse: {
    label: "Lacrosse",
    accent: "#38BDF8",
    rosterOnly: true,
    positions: ["Attack", "Midfield", "Defense", "Goalkeeper", "Draw Specialist"],
    stats: [],
    keyStats: [],
    logColumns: [],
  },
  beach: {
    label: "Beach Volleyball",
    accent: "#FB923C",
    rosterOnly: true,
    positions: [],
    stats: [],
    keyStats: [],
    logColumns: [],
  },
  rugby: {
    label: "Women's Rugby",
    accent: "#84CC16",
    rosterOnly: true,
    positions: ["Prop", "Hooker", "Lock", "Flanker", "No. 8", "Scrum-half", "Fly-half", "Centre", "Wing", "Fullback"],
    stats: [],
    keyStats: [],
    logColumns: [],
  },
};

const LEGACY_LABELS = { aces: "Aces", blocks: "Blocks", hitting_pct: "Hit %", sets_played: "Sets", minutes: "Minutes",
  xg: "Box Score xG", xg_per_game: "xG / Game", npxg: "npxG", goals_minus_xg: "Goals − xG" };

export const XG_KEYS = ["xg", "npxg", "xg_per_game", "goals_minus_xg", "finishing_rate", "finishing_low", "finishing_high",
  "np_shots", "xg_league_rate", "pbp_games", "pk_shots"];

export const TEST_PRESETS = [
  { test: "Vertical Jump", unit: "in" },
  { test: "Approach Jump", unit: "in" },
  { test: "Broad Jump", unit: "in" },
  { test: "10m Sprint", unit: "s" },
  { test: "40yd Dash", unit: "s" },
  { test: "Pro Agility (5-10-5)", unit: "s" },
  { test: "Yo-Yo IR1", unit: "m" },
];

export const SOURCE_LABELS = {
  fanflare: "FanFlare",
  testing_app: "Testing App",
  manual: "Manual entry",
  sample: "Sample data",
  school_roster: "School roster",
};

export const AGE_RANGE = [14, 40];
export const HEIGHT_RANGE = [58, 84];

export const fmtHeight = (inches) => (inches ? `${Math.floor(inches / 12)}'${inches % 12}"` : "—");

export const statLabel = (sport, key) =>
  SPORTS[sport]?.stats.find((s) => s.key === key)?.label || LEGACY_LABELS[key] || key.replace(/_/g, " ");

export const fmtStat = (key, value) => {
  if (value === undefined || value === null) return "—";
  if (key.startsWith("xg") || key === "npxg" || key === "goals_minus_xg") return Number(value).toFixed(2);
  if (key === "hitting_pct" || key === "hitting_percentage") return Number(value).toFixed(3).replace(/^0/, "");
  return Number.isInteger(value) ? value.toLocaleString() : Number(value).toFixed(1);
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—");
